import * as yup from 'yup';

import { isValidURL } from 'src/common/helpers';

// Form Validation

const LINK_REQUIRED = 'invalid URL';
const TITLE_REQUIRED = 'invalid title';

const addWriteupValidationObject = {
  title: yup.string().required(TITLE_REQUIRED),
  link: yup
    .string()
    .test('url-validation', LINK_REQUIRED, (value) => isValidURL(value ?? ''))
    .required(),
};

// Add Term
export const addWriteupFormValidation = yup.object(addWriteupValidationObject);
export type AddWriteupFormInput = yup.InferType<typeof addWriteupFormValidation>;
